function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useState, useContext, useReducer, useRef } from 'react';
import { Grid, message } from 'antd';
import Typography from "../typography";
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';
import { ErrorFilled } from 'iglooicon';
import LocaleContext from "../locale/locale-context";
import Modal from "../modal";
import Password from "../input/password";
import Button from "../button";
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var useBreakpoint = Grid.useBreakpoint;
var PasswordResponses = {
  NEED_PASSWORD: 1,
  INCORRECT_PASSWORD: 2
};
var PDF = function PDF(_ref) {
  var src = _ref.src;
  var _useState = useState(1),
    _useState2 = _slicedToArray(_useState, 2),
    pageSize = _useState2[0],
    setPageSize = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    needPassword = _useState4[0],
    setNeedPassword = _useState4[1];
  var _useBreakpoint = useBreakpoint(),
    md = _useBreakpoint.md;
  var _useReducer = useReducer(function (a) {
      return a + 1;
    }, 0),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    index = _useReducer2[0],
    update = _useReducer2[1];
  var documentRef = useRef(null);
  var _useContext = useContext(LocaleContext),
    formatMessage = _useContext.formatMessage;
  var handlePageInit = function handlePageInit(document) {
    var _ref2 = document || {},
      numPages = _ref2.numPages;
    if (numPages !== pageSize) {
      setPageSize(numPages);
    }
  };
  var handleCancelLoad = function handleCancelLoad() {
    var current = documentRef === null || documentRef === void 0 ? void 0 : documentRef.current;
    if (current) {
      // @ts-ignore
      current.setState({
        pdf: false
      });
    }
    setNeedPassword(true);
  };
  var onPassword = function onPassword(callback, reason) {
    if (reason) {
      var password = '';
      if (reason === PasswordResponses.INCORRECT_PASSWORD) {
        message.error(formatMessage({
          id: 'Invalid password.'
        }));
      }
      Modal.confirm({
        title: formatMessage({
          id: 'Enter the password to open this PDF file.'
        }),
        maskClosable: false,
        content: /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(Password, {
            onChange: function onChange(event) {
              return password = event.target.value;
            },
            placeholder: "input password"
          })
        }),
        okText: formatMessage({
          id: 'Ok'
        }),
        cancelText: formatMessage({
          id: 'Cancel'
        }),
        onOk: function onOk() {
          return callback(password);
        },
        onCancel: handleCancelLoad
      });
    }
  };
  var reopen = function reopen() {
    setNeedPassword(false);
    update();
  };
  if (needPassword) {
    return /*#__PURE__*/_jsx(Button, {
      onClick: reopen,
      type: "text",
      children: formatMessage({
        id: 'This is an encrypted file, click to enter password.'
      })
    });
  }
  return /*#__PURE__*/_jsx("div", {
    className: "igloo-upload-preview-pdf",
    children: /*#__PURE__*/_jsx(Document, {
      file: src,
      onLoadSuccess: handlePageInit,
      onPassword: onPassword,
      children: Array.from({
        length: pageSize
      }).map(function (_, index) {
        return /*#__PURE__*/_jsx(Page, {
          pageNumber: index + 1,
          scale: md ? 1 : 0.5
        }, index);
      })
    }, index)
  });
};
var Media = function Media(_ref3) {
  var src = _ref3.src,
    type = _ref3.type,
    className = _ref3.className;
  var _useContext2 = useContext(LocaleContext),
    formatMessage = _useContext2.formatMessage;
  var children = /*#__PURE__*/_jsxs("div", {
    className: "igloo-upload-prevew-not-supported",
    children: [/*#__PURE__*/_jsx(ErrorFilled, {
      className: "igloo-upload-prevew-not-supported-icon"
    }), /*#__PURE__*/_jsx(Typography, {
      level: "body1",
      className: "igloo-upload-prevew-not-supported-text",
      children: formatMessage({
        id: 'No preview for this file. Only support image, video or PDF file.'
      })
    })]
  });
  if (type === 'image') {
    children = /*#__PURE__*/_jsx("img", {
      className: "igloo-upload-preview-content",
      src: src
    });
  }
  if (type === 'video') {
    children = /*#__PURE__*/_jsx("video", {
      className: "igloo-upload-preview-content",
      src: src,
      controls: true,
      autoPlay: true
    });
  }
  if (type === 'pdf') {
    children = /*#__PURE__*/_jsx(PDF, {
      src: src
    });
  }
  return /*#__PURE__*/_jsx("div", {
    className: classNames('igloo-upload-preview-container', className),
    children: children
  });
};
export default Media;